export function formatRelativeDate(dateString, type) {
  // Parse the input date string into a Date object
  const givenDate = new Date(dateString);
  const now = new Date();

  // Calculate the difference in milliseconds
  const diff = now - givenDate;

  // Convert the difference to various units
  const diffInSeconds = Math.floor(diff / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);
  const diffInWeeks = Math.floor(diffInDays / 7);

  // format the time text
  const minute = type === "page" ? `minute${diffInMinutes > 1 ? "s" : ""}` : "min";
  const hour = type === "page" ? `hour${diffInHours > 1 ? "s" : ""}` : "hr";
  const day = type === "page" ? `day${diffInDays > 1 ? "s" : ""}` : "d";

  // Format the date based on the difference
  if (diffInSeconds < 60) {
    return "Just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} ${minute} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours} ${hour} ago`;
  } else if (diffInDays < 7) {
    return `${diffInDays} ${day} ago`;
  } else {
    // Format date as "Month, DD, YYYY, HH:MM AM/PM"
    const options = {
      month: "long",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return givenDate.toLocaleString("en-US", options);
  }
}
